jQuery(document).ready(function($) {

  $('.menu-links-toggle').on('click', function() {
    $('.left').toggleClass('menu-links--is-open')
  })

  $('.page-template-page-menus .menu-link a:not(.pdf)').on('click', function(e) {
    var $a = $(this)
    var $menuLink = $a.parent()
    var index = $menuLink.index()
    $('.page-template-page-menus .menu-link').removeClass('active')
    $menuLink.addClass('active')
    $('.left').removeClass('menu-links--is-open')
    $('.page-template-page-menus .menu-set').removeClass('menu-set--is-showing')
    $('.page-template-page-menus .menu-set').eq(index).addClass('menu-set--is-showing')
    var scrollTop = $('.page-template-page-menus .menu-container').offset().top
    scrollTop -= $(window).width() < 970 ? 60 : 0
    $('html, body').animate({ scrollTop: scrollTop  }, 500)
    $('.menu-links-toggle span').html($a.text())
    e.preventDefault()
  })

  var $venuesMenu = $('.venues-menu');
  var offsetTop = $venuesMenu.offset().top;
  if ($(window).width() < 970) {
    offsetTop -= 70;
  } else {
    offsetTop -= 50;
  }

  $(window).on('scroll', function() {
    if ($(window).scrollTop() >= offsetTop) {
      $venuesMenu.addClass('fixed');
    } else {
      $venuesMenu.removeClass('fixed');
    }
  });

  $('.venues-menu a').on('click', function(e) {
    e.preventDefault();
    var index = $(this).index() - 2;
    var $targetVenueSet = $('.venues-set').eq(index);
    if ($targetVenueSet.length) {
      var offset = $(window).width() < 970 ? -60 : -90;
      var speed = $(window).width() < 970 ? 750 : 500;
      $('html, body').animate({
        scrollTop: $targetVenueSet.offset().top + offset
      }, speed);
    }
    $('.venues-menu').removeClass('venues-menu--is-showing');
    $('.venues-menu .current-venue').html($(this).html());
  });

  $(window).on('scroll', function() {
    var scrollPosition = $(window).scrollTop() + 130; // Account for the 130px offset

    $('.venues-set').each(function(index) {
      var $this = $(this);
      var offsetTop = $this.offset().top;
      var offsetBottom = offsetTop + $this.outerHeight();

      if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
        $('.venues-menu a').removeClass('active');
        $('.venues-menu a').eq(index).addClass('active');
        $('.venues-menu .current-venue').html($('.venues-menu a').eq(index).html());
      }
    });
  });

  $('.venues-menu .current-venue').on('click', function() {
    $('.venues-menu').toggleClass('venues-menu--is-showing');
  });

  

  

})
